var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:`style_confirmAttendanceButton ${_vm.classDiv_val}`,style:(_vm.optionalCustomStyle),attrs:{"title":"Confirm Booking"},on:{"click":function($event){$event.stopPropagation();return _vm.modal_open_event.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.title_val)+" "+_vm._s(_vm.dateConfirm)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }